export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_07-a70e7c2fbf38b22ec89f1e534dc30a3e.png";